/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */

export type RichiestaPreventivoTipo =
  (typeof RichiestaPreventivoTipo)[keyof typeof RichiestaPreventivoTipo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RichiestaPreventivoTipo = {
  lubrifica: "lubrifica",
  lavorazioniMeccaniche: "lavorazioniMeccaniche",
} as const;
